import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import BotaoAdicionar from '../imagens/CadastroRegistro/BotaoAdicionar.png';
import CadastroClientesForm from '../imagens/CadastroRegistro/CadastroClientesForm.png';
import AlterarExcluirRegistro1 from '../imagens/CadastroRegistro/AlterarExcluirRegistro1.png';

export default class CadastroRegistro extends Component {

  render() {

    const { isOpen, onClose } = this.props;

    return (
      <Modal
        title="Como cadastrar um novo registro"
        className="modal"
        visible={isOpen}
        destroyOnClose
        onCancel={onClose}
        footer={null}
        width="50%"
        style={{ top: 10 }}
      >
        <Row>
          <p style={{ fontSize: 18, marginTop: 18 }}>
            Dentro da tela de cadastro clicar no botão adicionar que está no canto superior esquerdo da tela.
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={BotaoAdicionar} alt="Botão adicionar" />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 26 }}>
            Após clicar no botão "Adicionar" e a janela de cadastro for aberta, preencher as informações corretamente, os campos com (*) são obrigatórios.
            Com todos os campos preenchidos só clicar no botão "SALVAR".
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={CadastroClientesForm} alt="Tela de cadastro" />
          </div>

          <div style={{ backgroundColor: '#A0A0A0', height: 2, width: '100%' }} />

          <p style={{ fontSize: 18, marginTop: 18 }}>
            Na tabela onde é exibido a lista dos registros, existe uma coluna (geralmente a última coluna) com alguns botões.
            Esses botões servem para alterar o registro (botão com o ícone de um lápis), a exclusão do registro (botão com o ícone da lixeira),
            ou imprimir o registro (botão com o icone de impressora).
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={AlterarExcluirRegistro1} alt="Filtro imagem 1" />
          </div>

        </Row>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tutoriais/CadastroRegistro.js